const model = [
    {
        "Tipo de deposito": "999",
        "Posição": "12345678"
    },
    {
        "Tipo de deposito": "CSL",
        "Posição": "78945612"
    },
    {
        "Tipo de deposito": "RCR",
        "Posição": "45612345"
    },
    {
        "Tipo de deposito": "RSS",
        "Posição": "14725836"
    },
    {
        "Tipo de deposito": "RSS",
        "Posição": "96385274"
    },
    {
        "Tipo de deposito": "RSS",
        "Posição": "74185236"
    },
    {
        "Tipo de deposito": "RCR",
        "Posição": "98562145"
    },
    {
        "Tipo de deposito": "999",
        "Posição": "14523698"
    },
    {
        "Tipo de deposito": "999",
        "Posição": "36521489"
    },
    {
        "Tipo de deposito": "999",
        "Posição": "95478624"
    },
];

export default model